import en from './strings.en';

const ru = {
    pay: 'Перейти к оплате',
    showInfo: 'показать информацию',
    payError: 'Невозможно произвести оплату, попробуйте позже',
};

export default { ru, en: { ...ru, ...en} };
